import {
    messageListMinorTextNext,
    messageListMajorTextNext,
    firstLineMultiColumnTypeRamp,
    firstLineMultilineColumnTypeRamp,
    full,
    medium,
    mediumTypeRampUpdates,
    compactTypeRampUpdates,
    fullTypeRampUpdates,
} from './messageListTextStyles.scss';

import { getDensityModeCssClass } from 'owa-fabric-theme';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import classnames from 'owa-classnames';

export const useMessageListTextStyle = (
    textType: 'Minor' | 'Major',
    isFirstLine?: boolean,
    isSingleLineView?: boolean
): string => {
    const isTypeRampUpdatesEnabled = isGlobalFeatureEnabled('mon-type-ramp');
    // Get the Proper text styles
    return classnames(
        textType == 'Minor' ? messageListMinorTextNext : messageListMajorTextNext,
        isSingleLineView !== undefined &&
            !isSingleLineView &&
            isFirstLine &&
            (isTypeRampUpdatesEnabled
                ? firstLineMultilineColumnTypeRamp
                : firstLineMultiColumnTypeRamp),
        isTypeRampUpdatesEnabled
            ? getDensityModeCssClass(
                  fullTypeRampUpdates,
                  mediumTypeRampUpdates,
                  compactTypeRampUpdates
              )
            : getDensityModeCssClass(full, medium, undefined)
    );
};
